<div id="content">
  <div class="col-12">
    <div id="errorSummary"></div>
  </div>
  <div class="overlay" *ngIf="!viewPage || isLoading">
    <h1 class="heading" [innerHtml]="'Loading' | translator:'base'">Loading...</h1>
    <img />
  </div>
  <div id="homePageContainer" *ngIf="viewPage">
    <section class="bg-light d-flex align-items-end hero" id="hero">
      <div class="container">
        <div class="row d-flex align-items-stretch">
          <div class="col-lg-4 order-lg-2">
            <div class="card text-white shadow-sm d-flex align-items-stretch border-0 rounded-0 bg-brand-dark h-100">
              <div class="card-body">
                <h2 class="text-white card-title h3" [innerHtml]="'welcomeBack' | translator:'base'">Welcome Back</h2>
                <p>
                  <span [innerHtml]="'welcome_box_1' | translator:'base'">Multi-factor authentication is now required to
                    access PSP</span>
                </p>
                <p>
                  <span [innerHtml]="'welcome_box_2' | translator:'base'">
                    By clicking the LOGIN button, you will be redirected to the
                  </span>
                  <span [innerHtml]="'welcome_box_3' | translator:'base'">
                    From here, you can create an account, log in, or reset your password.
                  </span>
                </p>
                <div>
                  <p class="d-flex align-items-center mb-1">
                    <i class="fa-solid fa-circle-play me-2" style="padding-top: 3px;" aria-hidden="true"></i>
                    <a href="https://tylertech.wistia.com/medias/0xrwx6huvz" target="_blank" id="linkForgotPassword"
                      name="linkForgotPassword" [title]="'NeedHelp' | translator:'base'"
                      [innerHtml]="'NeedHelp' | translator:'base'" [attr.aria-disabled]="!translatorService.translationsReady">
                      Forgot your password?
                    </a>
                  </p>
                  <p class="d-flex m-0">
                    <i class="fa-solid fa-circle-play me-2" style="padding-top: 3px;" aria-hidden="true"></i>
                    <a href="https://tylertech.wistia.com/medias/b1lzvgj3hb" target="_blank"
                      [innerHtml]="'PasswordVideo' | translator:'base'"
                      [attr.aria-label]="'PasswordVideoTitle' | translator:'base'"
                      [title]="'PasswordVideoTitle' | translator:'base'" id="forgotPwdVideo" name="forgotPwdVideo" [attr.aria-disabled]="!translatorService.translationsReady">
                      Need help Creating your Login.gov Account?
                    </a>
                  </p>
                </div>
              </div>
              <div class="card-footer">
                <div class="form-group d-flex mb-0">
                  <button (click)="redirectToLoginGov()" type="button" id="loginSubmit" name="loginSubmit"
                    class="btn btn-light btn-strong rounded-0 me-2"
                    [innerHtml]="'navbar_login_link' | translator:'base'"
                    [title]="'navbar_login_link' | translator:'base'" [disabled]="!translatorService.translationsReady">
                    Login
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-8">
            <div class="h-100">
              <div class="card text-light shadow-sm border-0 rounded-0 bg-opacity-80 h-100">
                <div class="card-body">
                  <h1 class="text-white card-title" [innerHtml]="'landing1' | translator:'base'">
                    PSP has the data that you need to hire safe drivers.
                  </h1>
                  <p class="lead card-text mb-0">
                    <span [innerHtml]="'landing2' | translator:'base'">
                      Companies using PSP to screen new hires
                      <strong>lower their crash rate by 8%</strong>
                      and
                      <strong>driver out-of-service rates by 17%</strong>,
                      on average, compared to those that do not use PSP.
                    </span>
                    <span [innerHtml]="'Enroll today!' | translator:'base'">Enroll today!</span>
                  </p>
                </div>
                <div class="card-footer">
                  <a [routerLink]="!translatorService.translationsReady ? null : '/signup/welcome'" (click)="scrollToTop()" class="btn btn-light me-2 btn-strong"
                    [innerHtml]="'Enroll' | translator:'base'" [title]="'Enroll' | translator:'base'" id="enrollNow"
                    name="enrollNow" role="button" [attr.aria-disabled]="!translatorService.translationsReady">
                    Enroll
                  </a>
                  <a [routerLink]="!translatorService.translationsReady ? null : '/FAQ'" class="btn btn-outline-light" name="linkFAQ" id="linkFAQ" role="button"
                    [innerHtml]="'HomeVeteransLink' | translator:'veterans'"
                    [title]="'HomeVeteransLink' | translator:'veterans'" [attr.aria-disabled]="!translatorService.translationsReady">
                    Learn More
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="bg-light" id="sections">
      <div class="container">
        <div class="row d-flex align-items-stretch" id="buckets">
          <div class="col-lg-4">
            <div class="card shadow-sm rounded-0 border-0 h-100">
              <img class="card-img-top w-100 d-block rounded-0" src="assets/content/css/images/card-banner-01.jpg"
                alt="Commercial Driver" />
              <div class="card-body">
                <h2 class="card-title text-brand-dark h5" [innerHtml]="'areDriver' | translator:'base'">
                  Are you a driver?
                </h2>
                <p class="card-text">
                  <span [innerHtml]="'home_driver_card' | translator:'base'">
                    You can use PSP to request and review your personal driving record at any time. The PSP report pulls
                    your 5-year crash and 3-year roadside inspection history. You can also sign up to receive a
                    notification through PSP Monitoring every time your PSP record is updated. This helps you keep track
                    of changes to your PSP record. Previously requested records can be viewed for 5 days or 120 hours.
                  </span>&nbsp;
                  <a [routerLink]="!translatorService.translationsReady ? null : '/signin'" [queryParams]="{ as: 'driver' }" (click)="scrollToTop()"
                    [innerHtml]="'PreviousReq_link' | translator:'base'"
                    [title]="'PreviousReq_link' | translator:'base'" id="login-to-view-your-records"
                    name="login-to-view-your-records" [attr.aria-disabled]="!translatorService.translationsReady">
                    Log into your account
                  </a>
                  <span [innerHtml]="'PreviousReq_To_View' | translator:'base'">now to view past record.</span>
                </p>
              </div>
              <div class="card-footer bg-white">
                <a [routerLink]="!translatorService.translationsReady ? null : '/driver/1'" class="btn btn-primary btn-strong" id="linkRequestRecords"
                  name="linkRequestRecords" (click)="!translatorService.translationsReady && $event.preventDefault(); scrollToTop()" [innerHtml]="'RequestYourRec' | translator:'base'"
                  [title]="'RequestYourRec' | translator:'base'" [attr.aria-disabled]="!translatorService.translationsReady">
                  Request Your Record
                </a>
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="card shadow-sm rounded-0 border-0 h-100">
              <img class="card-img-top w-100 d-block rounded-0" src="assets/content/css/images/card-banner-02.jpg"
                alt="Military Veteran" />
              <div class="card-body">
                <h3 class="card-title text-brand-dark h5" [innerHtml]="'HomeVeteranHeader' | translator:'veterans'">
                  Are you a military veteran?
                </h3>
                <p class="card-text">
                  <span [innerHtml]="'home_vet_card' | translator:'base'">
                    Over 10% of commercial drivers in the U.S. have transitioned from military service to truck and bus
                    drivers. As you continue your desire to support America, learn how your driving record data is
                    captured and shared as you enter the commercial transportation industry. If you are interested in a
                    career as a truck or bus driver, you'll want to know about the Pre-Employment Screening Program
                    (PSP).
                  </span>&nbsp;
                  <a [routerLink]="!translatorService.translationsReady ? null : '/veterans'" (click)="!translatorService.translationsReady && $event.preventDefault(); scrollToTop()"
                    [innerHtml]="'Online_PSP_card_2' | translator:'veterans'"
                    [title]="'Online_PSP_card_2' | translator:'veterans'" [attr.aria-disabled]="!translatorService.translationsReady">
                    Click here
                  </a>
                  <span [innerHtml]="'vet_card_to_learn_more' | translator:'base'"> to learn more!</span>
                </p>
              </div>
              <div class="card-footer bg-white">
                <a [routerLink]="!translatorService.translationsReady ? null : '/veterans'" (click)="!translatorService.translationsReady && $event.preventDefault(); scrollToTop()" class="btn btn-primary btn-strong" id="veteransLink"
                  name="veteransLink" [innerHtml]="'HomeVeteransLink' | translator:'veterans'"
                  [title]="'HomeVeteransLink' | translator:'veterans'" role="button" [attr.aria-disabled]="!translatorService.translationsReady">
                  Learn More
                </a>
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="card shadow-sm rounded-0 border-0 h-100">
              <img class="card-img-top w-100 d-block rounded-0" src="assets/content/css/images/card-banner-03.jpg"
                alt="Man with Mobile Devices" />
              <div class="card-body">
                <h2 class="card-title text-brand-dark h5" [innerHtml]="'WhatIsMonitoring' | translator:'driver'">
                  What is PSP Monitoring?
                </h2>
                <p class="card-text" [innerHtml]="'home_what_card' | translator:'base'">
                  PSP Monitoring is an optional new service that automatically informs drivers when their PSP data
                  changes. Drivers who subscribe for the free monitoring service will receive an email each time their
                  PSP record changes. This PSP monitoring service is offered free of charge and is for use by drivers
                  only. To enroll you will need to log into PSP and go to the Driver Dashboard, then click on Enroll in
                  PSP Monitoring.
                </p>
              </div>
              <div class="card-footer bg-white">
                <button  [routerLink]="!translatorService.translationsReady ? null : '/driver/1/subscribe'"
                    (click)="!translatorService.translationsReady && $event.preventDefault(); scrollToTop()" type="button" id="subscribeToMonitoring"
                  name="subscribeToMonitoring" class="btn btn-primary btn-strong"
                  [innerHtml]="'driver_subscribe' | translator:'base'"
                  [title]="'driver_subscribe' | translator:'base'">
                  Subscribe
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="text-white bg-brand" id="help-footer">
      <div class="container">
        <div class="row d-flex align-items-center">
          <div class="col-lg-8">
            <h2 class="text-white h4">Need Assistance?</h2>
            <p class="mb-0">
              <span class="contact-us-subheading">Do you have any questions about accessing a PSP record or wish to
                enroll in the program? We are happy to help!</span>&nbsp;
          <span [innerHtml]="'ContactUsHelpText' | translator:'base'">
               The PSP customer service team is available Monday through Thursday from 8 AM to 6 PM ET, and on Friday from 8 AM to
               5 PM ET. To chat with an online representative, click the "LIVE HELP" button in the top-right corner of this page.
               You can also email us at <a href="mailto:PSPhelp@tylertech.com\"
                  title="PSPhelp@tylertech.com">PSPhelp&#64;tylertech.com</a> or call us toll-free at <a href="tel:1-877-642-9499"
                  title="1-877-642-9499">1-877-642-9499</a>.
          </span>
            </p>
          </div>
          <div class="col-lg-4 py-3">
            <p>
              <a href="https://x.com/PSP_help"
                class="btn btn-light btn-block d-flex justify-content-center align-items-center btn-brand"
                target="_blank" 
                aria-label="PSP on X" 
                title="PSP X">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="fab bi bi-twitter-x me-2" viewBox="0 0 16 16">
                  <path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z"/>
                </svg>
              </a>
            </p>
            <p class="mb-0">
              <a href="https://www.facebook.com/FMCSA/"
                class="btn btn-light btn-block d-flex justify-content-center align-items-center btn-brand"
                target="_blank" aria-label="FMCSA Facebook" title="FMCSA Facebook">
                <i class="fab fa-facebook me-2"></i>Facebook
              </a>
            </p>
          </div>
        </div>
      </div>
    </section>
    <section class="text-white bg-brand" id="dataQs-footer" name="dataQs-footer">
      <div class="container">
        <div class="row d-flex align-items-center">
          <div class="col-lg-8">
            <h2 class="text-white h4">Have Questions Regarding the Accuracy of a Driver Record?</h2>
            <p class="mb-0">
              Do you have questions regarding the accuracy of a driver record and/or believe your PSP record is
              incorrect or
              incomplete, the FMCSA’s DataQ’s team can help. The DataQs system assists users including, motor carriers,
              drivers and
              their representatives in improving the accuracy of data provided by the FMCSA's data-driven safety
              systems. To get
              started, just click on the Create a DataQs account button to be taken to the official FMCSA DataQ’s page.
            </p>
          </div>
          <div class="col-lg-4 py-3">
            <p>
              <a href="https://dataqs.fmcsa.dot.gov/"
                class="btn btn-light btn-block d-flex justify-content-center align-items-center btn-brand"
                target="_blank" aria-label="Create a DataQs Account link" id="dataQs-nav" name="dataQs-nav" role="link"
                title="DataQs">
                <i class="fa fa-link me-2"></i>Create a DataQs Account
              </a>
            </p>
          </div>
        </div>
      </div>
    </section>
    <section class="text-white bg-brand" id="updates-footer">
      <div class="container">
        <div>
          <div class="row d-flex align-items-center">
            <div class="col-lg-8">
              <h2 class="text-white h4" [innerHtml]="'Subscribe' | translator:'base'">Subscribe to Updates</h2>
              <p [innerHtml]="'subscribe_text' | translator:'base'">Get notified when the latest data snapshot is loaded
                to PSP.</p>
              <p class="mb-0">
                <strong [innerHtml]="'DateCurrent' | translator:'base'">Data current as of:</strong>&nbsp;{{
                this.configDataService.updateDate.mcmisUploadDate }}&nbsp;
                <strong [innerHtml]="'NextUpdate' | translator:'base'">Next update is projected the week of:</strong>&nbsp;{{
                configDataService.updateDate.nextMCMISUploadDate }}
              </p>
            </div>
            <div class="col-lg-4 py-3">
              <a href="https://cdn.forms-content.sg-form.com/8d2a82a8-412b-11ee-bbc6-6e5be17f2960" target="_blank" 
                (click)="$event.preventDefault()"
                class="btn btn-light btn-block  justify-content-center align-items-center btn-brand w-100"
                style="display: none;" 
                [title]="'PSPUpdateTitle' | translator:'base'" id="pspUpdates" name="pspUpdates">
                <i class="fas fa-envelope me-2"></i>
                <span [innerHtml]="'PSPUpdateTitle' | translator:'base'">PSP Updates</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="text-white bg-brand" id="updates-footer">
      <div class="container">
        <div>
          <div class="row d-flex align-items-center">
            <div class="col-lg-8">
              <h2 class="text-white h4" [innerHtml]="'home_motus_resources' | translator:'base'">New FMCSA Motus Rollout Resources Available</h2>
              <p [innerHtml]="'home_motus_resources_txt' | translator:'base'">Visit the new FAQ for FMCSA Motus rollout support, updates, and contact information.</p>
              
            </div>
            <div class="col-lg-4 py-3">
              <button type="button" (click)="openMotusResourcesModal()"
                class="btn btn-light btn-block d-flex justify-content-center align-items-center btn-brand w-100"
                [title]="'home_motus_resources_button' | translator:'base'" 
                id="home_motus_resources_button" 
                name="home_motus_resources_button"
                [disabled]="!translatorService.translationsReady">
                <i class="fas fa-up-right-from-square me-2"></i>
                <span [innerHtml]="'home_motus_resources_button' | translator:'base'">Motus: USDOT Registration System</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="text-white bg-brand" id="psp-footer">
      <div class="container">
        <div class="row d-flex align-items-center">
          <div class="col-lg-8">
            <h2 class="text-white h4" [innerHtml]="'aboutPSP' | translator:'base'">About PSP</h2>
            <p [innerHtml]="'PSPHelp' | translator:'base'" class="mb-0">PSP helps carriers make more informed hiring
              decisions by providing secure, electronic access to a
              commercial driver's five-year crash and three-year inspection history from the FMCSA Motor Carrier
              Management Information System (MCMIS). Records are available for commercial drivers, motor carriers, and
              companies conducting pre-employment screening for the carrier industry.
            </p>
          </div>
          <div class="col-lg-4 py-3">
            <p>
              <a href="https://x.com/PSP_help"
                class="btn btn-light btn-block d-flex justify-content-center align-items-center btn-brand"
                target="_blank" 
                aria-label="PSP on x" 
                title="PSP X">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="fab bi bi-twitter-x me-2" viewBox="0 0 16 16">
                  <path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z"/>
                </svg> 
              </a>
            </p>
            <p class="mb-0">
              <a href="https://www.facebook.com/FMCSA/"
                class="btn btn-light btn-block d-flex justify-content-center align-items-center btn-brand"
                target="_blank" aria-label="FMCSA Facebook" id="fmcsaFb" name="fmcsaFb" title="FMCSA Facebook">
                <i class="fab fa-facebook me-2" aria-hidden="true"></i>Facebook
              </a>
            </p>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>

<ng-template #MotusResourcesModal let-modal>
  <div class="modal-header d-flex justify-content-between align-items-center" style="background-color: #1C6DA6;">
    <h3 id="motusResourcesModalTitle" class="modal-title text-white mb-0">
      <span [innerHtml]="'home_motus_modal_title' | translator:'base'">New FMCSA Motus Rollout Resources Available</span>
    </h3>
    <button 
      type="button" 
      class="btn btn-link text-white p-0 ms-auto border-0 shadow-none" 
      style="text-decoration: none; outline: none !important; box-shadow: none !important;"
      aria-label="Download as PDF" 
      [title]="'home_motus_modal_download_pdf' | translator:'base'" 
      (click)="downloadMotusModalAsPDF()"
      [disabled]="!translatorService.translationsReady">
      <i class="fas fa-file-pdf fa-lg"></i>
    </button>
  </div>
  <div class="modal-body" id="motusResourcesModalBody">
    <p class="py-3" [innerHtml]="'home_motus_modal_intro' | translator:'base'">As part of FMCSA's introduction of <strong>Motus: USDOT Registration System</strong>, the following resources and support options are available to help users navigate updates and get assistance.</p>
    
    <div class="py-3 border-bottom border-secondary">
      <h4 class="h6 fw-bold" [innerHtml]="'home_motus_resources_hub_title' | translator:'base'">Where can I find official information about the Motus rollout?</h4>
      <p class="mb-0" ><span [innerHtml]="'home_motus_resources_hub_text' | translator:'base'">Visit the FMCSA Registration Modernization Resources Hub for the latest updates, guidance, and materials:</span><br>
      <a href="https://www.fmcsa.dot.gov/registration/resources-hub" [title]="'home_motus_resources_hub' | translator:'base'" target="_blank" rel="noopener noreferrer">https://www.fmcsa.dot.gov/registration/resources-hub</a></p>
    </div>

    <div class="py-3 border-bottom border-secondary">
      <h4 class="h6 fw-bold" [innerHtml]="'home_motus_resources_contact_title' | translator:'base'">How can I contact FMCSA with questions about Motus?</h4>
      <p class="mb-0" ><span [innerHtml]="'home_motus_resources_contact_text' | translator:'base'">You can reach the FMCSA Registration team directly by email:</span><br>
      <a href="mailto:NewRegSys@dot.gov" [title]="'home_motus_resources_email' | translator:'base'">NewRegSys&#64;dot.gov</a></p>
    </div>

    <div class="py-3 border-bottom border-secondary">
      <h4 class="h6 fw-bold" [innerHtml]="'home_motus_resources_connect_title' | translator:'base'">How do I stay informed about Motus updates and announcements?</h4>
      <p class="mb-0" ><span [innerHtml]="'home_motus_resources_connect_text' | translator:'base'">Sign up for notifications through the "Connect with Us" page:</span><br>
      <a href="https://www.fmcsa.dot.gov/registration/connect" [title]="'home_motus_resources_connect' | translator:'base'" target="_blank" rel="noopener noreferrer">https://www.fmcsa.dot.gov/registration/connect</a></p>
    </div>

    <div class="py-3 border-bottom border-secondary">
      <h4 class="h6 fw-bold" [innerHtml]="'home_motus_resources_ticket_title' | translator:'base'">How do I submit a support request or get help online?</h4>
      <p class="mb-0" ><span [innerHtml]="'home_motus_resources_ticket_text' | translator:'base'">You can submit a ticket through the FMCSA support webform:</span><br>
      <a href="https://ask.fmcsa.dot.gov/app/ticket" [title]="'home_motus_resources_ticket' | translator:'base'" target="_blank" rel="noopener noreferrer">https://ask.fmcsa.dot.gov/app/ticket</a><br>
      <span [innerHtml]="'home_motus_resources_best_option' | translator:'base'">This is the best option for tracking questions and receiving detailed responses.</span></p>
    </div>

    <div class="py-3 border-bottom border-secondary">
      <h4 class="h6 fw-bold" [innerHtml]="'home_motus_resources_phone_title' | translator:'base'">Is there a phone number for customer support?</h4>
      <p class="mb-0" [innerHtml]="'home_motus_resources_phone_text' | translator:'base'">Yes, you can contact the FMCSA Registration Customer Service Center at:<br>
      <strong>1-800-832-5660</strong></p>
    </div>

    <div class="py-3">
      <h4 class="h6 fw-bold" [innerHtml]="'home_motus_resources_which_resource_title' | translator:'base'">Which resource should I use?</h4>
      <ul class="mb-0">
        <li [innerHtml]="'home_motus_resources_which_resource_general' | translator:'base'"><strong >General information & updates:</strong> Resources Hub</li>
        <li [innerHtml]="'home_motus_resources_which_resource_updates' | translator:'base'"><strong >Ongoing updates & alerts:</strong> "Connect with Us" subscription</li>
        <li [innerHtml]="'home_motus_resources_which_resource_specific' | translator:'base'"><strong >Specific questions or issues:</strong> Submit a ticket or email support</li>
        <li [innerHtml]="'home_motus_resources_which_resource_immediate' | translator:'base'"><strong >Immediate assistance:</strong> Call the Customer Service Center</li>
      </ul>
    </div>
  </div>
  <div class="modal-footer">
    <button 
      class="btn btn-secondary" 
      title="Close" 
      name="close-motus-modal" 
      id="close-motus-modal" 
      (click)="closeMotusResourcesModal()"
      [disabled]="!translatorService.translationsReady">
      <span [innerHtml]="'Close' | translator:'base'">Close</span>
    </button>
  </div>
</ng-template>